const INITIAL_STATE = {
  data: null,
  error: null,
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SAVE_LOCATION_SUCCESS":
      return { ...state, data: action.payload };

    case "SAVE_LOCATION_FAIL":
      return { ...state, error: action.payload };

    default:
      return state;
  }
};
